import ArchiveModal from './ArchiveModal';

export default ArchiveModal;
